import { PRODUCT_IDS } from '@adsk/alloy-provider';
import {
  SERVICES,
  SERVICE_ACCESSES,
  SERVICES_PRODUCTS_MAP,
} from '@adsk/acs-admin-ui-components-helpers';
import { getProjectUserServicesAccess } from '../../utils';

export const getMemberProductsAccessesFromServices = (memberServices) => {
  if (!memberServices) return {};

  return SERVICES_PRODUCTS_MAP.reduce((result, map) => {
    if (!result[map.product]) {
      const services = SERVICES_PRODUCTS_MAP.filter(
        (e) => e.product === map.product
      ).map((e) => e.service);

      return {
        ...result,
        [map.product]: services.some((service) =>
          memberServices.some(
            (memberService) =>
              memberService.serviceName === service &&
              memberService.access !== SERVICE_ACCESSES.NONE
          )
        ),
      };
    }

    return result;
  }, {});
};

export const getMemberProductsAccessesFromProducts = (memberProducts) => {
  if (!memberProducts) return {};

  return memberProducts.reduce(
    (result, product) => ({
      ...result,
      [product.key]: product.access !== SERVICE_ACCESSES.NONE,
    }),
    {}
  );
};

const getServicesNamesFromProductType = (productType) =>
  SERVICES_PRODUCTS_MAP.filter((map) => map.product === productType).map(
    (map) => map.service
  );

const getUpdatedMemberServicesAccess = (
  previousServicesAccess,
  selectedAccessLevel,
  type,
  activated
) => {
  const servicesNames = getServicesNamesFromProductType(type);
  const serviceAccessLevel = activated
    ? selectedAccessLevel.value
    : SERVICE_ACCESSES.NONE;
  const services = previousServicesAccess.map((s) => {
    let service = s;
    if (
      servicesNames.includes(s.serviceName) ||
      (activated &&
        type !== PRODUCT_IDS.DOCS &&
        s.serviceName === SERVICES.DOCUMENT_MANAGEMENT &&
        s.access === SERVICE_ACCESSES.NONE) ||
      (activated &&
        s.serviceName === SERVICES.INSIGHT &&
        s.access === SERVICE_ACCESSES.NONE)
    ) {
      service = {
        ...s,
        access: serviceAccessLevel,
      };
    }

    return service;
  });

  return services;
};

const getUpdatedMemberProductsAccess = (
  previousProductsAccess,
  selectedAccessLevel,
  type,
  activated,
  productIds
) =>
  productIds.map((product) => {
    let productAccess = SERVICE_ACCESSES.NONE;
    if (
      (type === product && activated) ||
      (type !== product &&
        product !== PRODUCT_IDS.PROJECT_ADMINISTRATION &&
        previousProductsAccess.some(
          (p) => p.key === product && p.access !== SERVICE_ACCESSES.NONE
        )) ||
      (product === PRODUCT_IDS.PROJECT_ADMINISTRATION &&
        selectedAccessLevel.value === SERVICE_ACCESSES.ADMIN) ||
      (activated &&
        (product === PRODUCT_IDS.DOCS || product === PRODUCT_IDS.INSIGHT))
    ) {
      productAccess = selectedAccessLevel.value;
    }

    return {
      key: product,
      access: productAccess,
    };
  });

export const getUpdatedMemberAccess = (
  prevMemberAccess,
  projectServices,
  selectedAccessLevel,
  type,
  activated,
  useWriteConstructionApis,
  productIds
) => {
  if (useWriteConstructionApis) {
    return getUpdatedMemberProductsAccess(
      prevMemberAccess,
      selectedAccessLevel,
      type,
      activated,
      productIds
    );
  }

  const memberProjectServices = getProjectUserServicesAccess(
    projectServices,
    prevMemberAccess,
    selectedAccessLevel.value
  );
  return getUpdatedMemberServicesAccess(
    memberProjectServices,
    selectedAccessLevel,
    type,
    activated
  );
};

export const getDocsOffAccessForAdmin = (
  projectServices,
  memberServices,
  useWriteConstructionApis,
  productIds
) => {
  if (useWriteConstructionApis) {
    return productIds.map((product) => {
      return {
        key: product,
        access:
          product === PRODUCT_IDS.PROJECT_ADMINISTRATION ||
          product === PRODUCT_IDS.INSIGHT
            ? SERVICE_ACCESSES.ADMIN
            : SERVICE_ACCESSES.NONE,
      };
    });
  }

  const memberProjectServices = getProjectUserServicesAccess(
    projectServices,
    memberServices,
    SERVICE_ACCESSES.NONE
  );
  const index = memberProjectServices.findIndex(
    (s) => s.serviceName === SERVICES.PROJECT_ADMIN
  );
  memberProjectServices[index].access = SERVICE_ACCESSES.ADMIN;

  return memberProjectServices;
};

export const projectProductsUpdated = (projectProducts, memberProductsAccess) =>
  !Object.entries(memberProductsAccess).some(([product, hasAccess]) => {
    const hasProduct = projectProducts.some(
      (projectProduct) => projectProduct.key === product
    );
    const hasAccountAdminAccess = projectProducts.some(
      (projectProduct) =>
        projectProduct.key === PRODUCT_IDS.ACCOUNT_ADMINISTRATION
    );

    if (
      product === PRODUCT_IDS.PROJECT_ADMINISTRATION &&
      !hasAccess &&
      hasAccountAdminAccess
    ) {
      return false;
    }

    return hasAccess !== hasProduct;
  });
